export const CHARGE_KINDS = {
  bolt: {
    label: "Bolt Charges",
    singular: "Bolt Charge",
    clearAtTurnEnd: false,
    description:
      "Crossbow ammunition loaded with Load Bolt. Spending Bolts fires each one as a separate hit. Bolt Charges persist until spent and cannot be added by effects that grant other kinds of charges.",
  },
  fletch: {
    label: "Fletch Charges",
    singular: "Fletch Charge",
    clearAtTurnEnd: false,
    description:
      "Placed on one slotted Ranged Active Ability by Fletch. They stack with no limit. When that ability is activated, all of its Fletch Charges are consumed and it deals +1 damage per charge.",
  },
  arcane: {
    label: "Arcane Charges",
    singular: "Arcane Charge",
    clearAtTurnEnd: false,
    description:
      "Stored spell energy on wands such as Charge Wand. Channeling gear (Channel Gloves, Iron-Sage Gauntlets, Spellthief Gloves) adds Arcane Charges to an equipped weapon that holds them. Persist until spent.",
  },
  earth: {
    label: "Earth Charges",
    singular: "Earth Charge",
    clearAtTurnEnd: true,
    description:
      "Gathered stone on Pillar of Earth. Earth Charges crumble at the end of your turn if not spent.",
  },
  nature: {
    label: "Nature Charges",
    singular: "Nature Charge",
    clearAtTurnEnd: false,
    description:
      "Living energy on Druid's Staff, spent in bundles for Strength, Dexterity, or Wisdom. Persist until spent.",
  },
  bulwark: {
    label: "Bulwark Charges",
    singular: "Bulwark Charge",
    clearAtTurnEnd: false,
    description:
      "Braced plating on Plated Cuirass, released all at once as Physical Armor. Persist until spent.",
  },
  focus: {
    label: "Focus Charges",
    singular: "Focus Charge",
    clearAtTurnEnd: false,
    description:
      "Limited concentration on Focus Charm, spent to empower slotted abilities. They do not recharge.",
  },
};

export function getChargeKindKeywordId(kind) {
  return `charge_${kind}`;
}

export function getChargeKindLabel(kind, amount = null) {
  const definition = CHARGE_KINDS[kind];
  if (!definition) return amount === 1 ? "Charge" : "Charges";
  return amount === 1 ? definition.singular : definition.label;
}

export function chargeKindClearsAtTurnEnd(kind) {
  return Boolean(CHARGE_KINDS[kind]?.clearAtTurnEnd);
}

export function getChargeCount(holder, kind) {
  const charges = holder?.charges;
  if (!kind || !charges || typeof charges !== "object") return 0;
  return Math.max(0, Math.floor(Number(charges[kind]) || 0));
}

export function getChargeKindKeywordEntries() {
  return Object.entries(CHARGE_KINDS).map(([kind, definition]) => ({
    id: getChargeKindKeywordId(kind),
    label: definition.label,
    aliases: [definition.singular],
    description: definition.description,
  }));
}
